import configClient from "../../api/hooks/config-client"

export const apiBaseURL = "/api/"
// export const baseURL = "https://tibi_starter.code.testversion.online.de"
export const release = configClient.release
